/* eslint import/no-webpack-loader-syntax: off */
import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { configure } from 'mobx';

import App from './DevPortalApp';

import config from './core/config';

import * as Sentry from '@sentry/browser';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import './normalize.min.css';
import './framework.min.css';
import './site.scss';

import './index.scss';
import './colors.scss';
import './dimensions.scss';
import './misc.scss';

// Disable MobX strict mode
configure({
  enforceActions: 'never',
});

window.onload = () => {
  if (process.env.REACT_APP_SENTRY_ENABLED === 'true') {
    Sentry.init({
      dsn: config.SENTRY_DSN,
      environment: config.SENTRY_ENV,
    });
  }
  const rootElement = document.getElementById('root');
  if (!rootElement) throw new Error('Failed to find the root element');
  const root = createRoot(rootElement);
  root.render(
    <Suspense fallback={null}>
      <App />
    </Suspense>
  );
};

// Service worker is now registered via register-sw.js
